"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dutyCategory = void 0;
exports.dutyCategory = function (axios) {
    return {
        getDutyCategories: function () {
            return axios.get('/duty-categories');
        },
        getDutyCategoriesV2: function () {
            return axios.get('/duty-categories');
        },
        getDutyCategoriesTemplates: function () {
            return axios.get('/duty-categories/templates');
        },
        getDutyCategoriesTemplatesV2: function () {
            return axios.get('/duty-categories/templates');
        },
        deleteDutyCategoriesTemplates: function (deleteDutyCategoriesTemplatesRequest) {
            var url = "/duty-categories/templates/" + deleteDutyCategoriesTemplatesRequest.params.no;
            return axios.delete(url, deleteDutyCategoriesTemplatesRequest);
        }
    };
};
